import React, { Component } from 'react';
import Butter from 'buttercms'
import { Link } from 'react-router'
import { Helmet } from "react-helmet";

import {} from '../App.css';

const butter = Butter('75d2c0d6325d45a1434fb429cb750f018d7c41d9');

class BlogPost extends Component {

  constructor(props) {
    super(props);
    document.title = "g-C3N4 Blog Post";

    this.state = {
      loaded: false
    };
  }

  componentWillMount() {
    let slug = this.props.params.slug;

    butter.post.retrieve(slug).then((resp) => {
      this.setState({
        loaded: true,
        post: resp.data.data
      })
    });
  }

  render() {
    if (this.state.loaded) {
      const post = this.state.post;

      return (
        <div className="container">
          <br/>
          <Link className="Article-research-link" to="/p/1">&lt; Back to Blogs</Link>
          <Helmet>
            <title>{post.seo_title}</title>
            <meta name="description" content={post.meta_description} />
            <meta name="og:image" content={post.featured_image} />
          </Helmet>

          <h1>{post.title}</h1>
          <div dangerouslySetInnerHTML={{__html: post.body}} />
        </div>
      );
    } else {
      return (
        <div>
          Loading...
        </div>
      );
    }
  }
}

export default BlogPost;


// WEBPACK FOOTER //
// ./src/Blog/BlogPost.js